import * as React from 'react'
// import ReactSVG from 'react-svg'

import classnames from 'classnames'
import { IFAQData } from './interfaces'
import { Section } from './Section'
import styles from './style.module.scss'

interface IReduxStateProps {}
interface IReduxDispatchProps {}
interface IReduxProps extends IReduxStateProps, IReduxDispatchProps {}
interface IProps extends IReduxProps {
  isMobile: boolean
}

const FAQDataFirst: IFAQData = {
  sections: [
    {
      name: 'What do I get with my purchase?',
      items: [
        {
          name: 'Access all the evaluation questionnaires and games',
          tickIcon: true
        },
        {
          name: "Unlock all the scores in your child's abilities map",
          tickIcon: true
        },
        {
          name:
            'Get detailed explanations of every ability and how it relates to your child’s day-to-day',
          tickIcon: true
        },
        {
          name: 'Receive premium support from our dedicated team',
          tickIcon: true
        }
      ],
      notices: ['Your purchase includes one full evaluation per child']
    }
  ]
}

const FAQDataSecond: IFAQData = {
  sections: [
    {
      name: 'What if I’m unsatisfied?',
      items: [
        {
          name: 'We provide a 7-day money-back guarantee'
        }
      ]
    },
    {
      name: 'What if I’m having trouble with the evaluation process?',
      items: [
        {
          name:
            'Contact us at support@giantleap.tech and we’ll walk you through the process'
        }
      ]
    }
  ]
}

export const FAQ: React.FC<IProps> = ({ isMobile }) => {
  return (
    <section className={styles.wrap}>
      <div className={styles.wrap__title}>
        <h2 className={styles.title}>
          {isMobile ? 'FAQ' : 'Frequently Asked Questions'}
        </h2>
      </div>
      <div className={styles.wrap__container}>
        <div className={styles.container}>
          <div
            className={classnames(
              styles.container__section,
              styles.container__section_first
            )}
          >
            {FAQDataFirst.sections.map((section, i) => (
              <div className={styles.section} key={i}>
                <Section section={section} isMobile={isMobile} />
              </div>
            ))}
          </div>
          <div
            className={classnames(
              styles.container__section,
              styles.container__section_second
            )}
          >
            {FAQDataSecond.sections.map((section, i) => (
              <div className={styles.section} key={i}>
                <Section section={section} isMobile={isMobile} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Payment/FAQ/index.tsx